module.exports = "https://coursera_assets.s3.amazonaws.com/images/f808c3255186cea5ebb596574bd468b7.png";